/**
 * tandem · short muted loops (How it works steps).
 * They play only while visible and only when motion is allowed; nothing loads before that.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const allowed = () => document.documentElement.dataset.tMotion === 'on' && !reducedMotion.matches;

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          for (const { target, isIntersecting } of entries) {
            const video = /** @type {HTMLVideoElement} */ (target);
            if (isIntersecting && allowed()) {
              video.muted = true;
              video.play().catch(() => {});
            } else if (!video.paused) {
              video.pause();
            }
          }
        },
        { threshold: 0.4 }
      )
    : null;

function init(scope = document) {
  scope.querySelectorAll('video.t-how__video, video.t-loop-video').forEach((video) => {
    if (video.dataset.tLoopBound) return;
    video.dataset.tLoopBound = 'true';
    video.muted = true;
    video.playsInline = true;
    observer?.observe(video);
  });
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
